import React from 'react';
import { useTranslation } from 'react-i18next';

function LocationHeaderCard({ story, title, address, sizeMultiplier }) {
    const { t } = useTranslation();
    const logo = story?.avatarUrl || "/images/avatar_placeholder.png";
    const logoSize = 48 * sizeMultiplier;

    if (!title && !address) {
        return null;
    }

    return (
        <div
            style={{
                position: 'absolute',
                top: 16 * sizeMultiplier,
                left: 16 * sizeMultiplier,
                right: 16 * sizeMultiplier,
                zIndex: 40,
                background: '#FFFFFF',
                borderRadius: 8 * sizeMultiplier,
                padding: 12 * sizeMultiplier,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 12 * sizeMultiplier,
                boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
                pointerEvents: 'none',
            }}
        >
            <img
                alt={t('RestaurantAvatarAlt')}
                src={logo}
                draggable={false}
                style={{
                    width: logoSize,
                    height: logoSize,
                    borderRadius: '50%',
                    objectFit: 'cover',
                    flexShrink: 0,
                    background: '#F5F5F5',
                }}
            />
            <div style={{ flex: 1, minWidth: 0 }}>
                {title ? (
                    <div
                        style={{
                            fontWeight: 700,
                            fontSize: Math.max(14, Math.round(16 * sizeMultiplier)),
                            color: '#1A1A1A',
                            lineHeight: 1.25,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {title}
                    </div>
                ) : null}
                {address ? (
                    <div
                        style={{
                            marginTop: title ? 4 * sizeMultiplier : 0,
                            fontWeight: 400,
                            fontSize: Math.max(12, Math.round(13 * sizeMultiplier)),
                            color: '#666666',
                            lineHeight: 1.35,
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                        }}
                    >
                        {address}
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default LocationHeaderCard;
